import type { ReactNode } from "react";
import { Card, Wordmark } from "@vavr/ui";

// The page heading is the h1; the card below carries no title of its own, so headings nest correctly.
export function AuthLayout({ title, description, children, footer }: { title: string; description?: ReactNode; children: ReactNode; footer?: ReactNode }) {
  return (
    <main className="pmu-auth">
      <div className="pmu-auth__card">
        <div className="pmu-auth__brand"><Wordmark withMark /></div>
        <h1 className="pmu-auth__title">{title}</h1>
        {description && <p className="pmu-auth__description pmu-muted">{description}</p>}
        <Card footer={footer}>{children}</Card>
      </div>
    </main>
  );
}
